"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationReason = void 0;
var DynamicConfig_1 = __importDefault(require("./DynamicConfig"));
var Layer_1 = __importDefault(require("./Layer"));
var BootstrapValidator_1 = __importDefault(require("./utils/BootstrapValidator"));
var Constants_1 = require("./utils/Constants");
var Hashing_1 = require("./utils/Hashing");
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
var EvaluationReason;
(function (EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})(EvaluationReason = exports.EvaluationReason || (exports.EvaluationReason = {}));
var MAX_USER_VALUE_CACHED = 10;
var StatsigStore = /** @class */ (function () {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = EvaluationReason.Uninitialized;
        if (initializeValues) {
            this.bootstrap(initializeValues);
        }
        else {
            this._loadFromLocalStorage();
        }
    }
    StatsigStore.prototype.updateUser = function () {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function (initializeValues) {
        var _a, _b, _c;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = BootstrapValidator_1.default.isValid(user, initializeValues)
            ? EvaluationReason.Bootstrap
            : EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = Date.now();
            this._values[key] = this._userValues;
            this._reason = reason;
        }
        catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.isLoaded = function () {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function (user) {
        var userHash = (0, Hashing_1.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) {
            return this._userValues.time;
        }
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function (user) {
        var userHash = (0, Hashing_1.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) {
            return this._userValues.derived_fields;
        }
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function (evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function (user, jsonConfigs, updateState) {
        if (updateState === void 0) { updateState = true; }
        return __awaiter(this, void 0, void 0, function () {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestedUserCacheKey = (0, Hashing_1.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function (userValues) { return userValues; });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues &&
                                requestedUserCacheKey &&
                                requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [4 /*yield*/, this._writeValuesToStorage(this._values)];
                    case 1:
                        _a._values = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function (gateName) {
        var _a;
        var gateNameHash = (0, Hashing_1.getHashValue)(gateName, this._userValues.hash_used);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: '',
            secondary_exposures: [],
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) {
            gateValue = value;
        }
        details = this._getEvaluationDetails(value != null);
        return { evaluationDetails: details, gate: gateValue };
    };
    StatsigStore.prototype.getConfig = function (configName) {
        var _a, _b;
        var configNameHash = (0, Hashing_1.getHashValue)(configName, this._userValues.hash_used);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        }
        else {
            details = this._getEvaluationDetails(false);
            configValue = new DynamicConfig_1.default(configName, {}, '', details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function (logParameterFunction, layerName) {
        var _a, _b, _c;
        var latestValue = this._getLatestValue(layerName, 'layer_configs');
        var details = this._getEvaluationDetails(latestValue != null);
        return Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : '', details, logParameterFunction, latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures, latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures, (_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _c !== void 0 ? _c : '', latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function () {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0,
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function () {
        this._parseCachedValues(StatsigLocalStorage_1.default.getItem(Constants_1.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function (allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        }
        catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage(Constants_1.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function () {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function (key) {
        StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */
    StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function (data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, Hashing_1.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function () {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false,
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */
    StatsigStore.prototype._writeValuesToStorage = function (valuesToWrite) {
        return __awaiter(this, void 0, void 0, function () {
            var filteredValues;
            return __generator(this, function (_a) {
                filteredValues = Object.entries(valuesToWrite)
                    .sort(function (_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) {
                        return 1;
                    }
                    if (b == null) {
                        return -1;
                    }
                    return (((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time));
                })
                    .slice(0, MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                StatsigLocalStorage_1.default.setItem(Constants_1.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [2 /*return*/, valuesToWrite];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function (name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, Hashing_1.getHashValue)(name, this._userValues.hash_used);
        return ((_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name]);
    };
    StatsigStore.prototype._createDynamicConfig = function (name, apiConfig, details) {
        var _a, _b, _c;
        return new DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : '', details, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures, (_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _c !== void 0 ? _c : '', this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function (valueExists, reasonOverride) {
        var _a;
        if (valueExists) {
            return {
                reason: this._reason,
                time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now(),
            };
        }
        else {
            return {
                reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : (this._reason == EvaluationReason.Uninitialized
                    ? EvaluationReason.Uninitialized
                    : EvaluationReason.Unrecognized),
                time: Date.now(),
            };
        }
    };
    StatsigStore.prototype._resetUserValues = function () {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function (data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields,
            hash_used: data.hash_used,
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function (user) {
        var _this = this;
        return function (config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) {
                return;
            }
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType,
            });
        };
    };
    return StatsigStore;
}());
exports.default = StatsigStore;
